// Shared, host-agnostic constants for the community gallery panel. The panel
// owns its own filter defaults and icon sizing so it carries no dependency on
// any consuming pod (ThreeDStudio, AI landing, etc.). Hosts that keep these
// values in their own store should re-export from here rather than redefine.

export const DEFAULT_COMMUNITY_GALLERY_FILTERS = {
  searchQuery: '',
  category: 'all',
  sortOrder: 'new',
}

export const iconSize = { height: '16px', width: '16px' }

// Anonymous visitors can page through this many gallery pages before the next
// page is gated behind sign up / log in. Mirrors the server-side cap in
// Api::Internal::Generator::CommunityGalleryController (ANONYMOUS_PAGE_LIMIT),
// which clamps the data; the client uses it to know when to prompt instead of
// letting the list silently end.
export const ANONYMOUS_PAGE_LIMIT = 2
